'use es6';

/**
 * Fork of UIComponents/nav/utils/navUtils
 * https://git.hubteam.com/HubSpot/UIComponents/blob/7f80f7c/UIComponents/static-3.3044/js/nav/utils/navUtils.js
 */
import { Children } from 'react';
export const isChildActive = (child, value) => {
  const childProps = child && child.props ? child.props : {};
  if (childProps.active === true) {
    return true;
  }
  if (value != null && childProps.value != null) {
    return value === childProps.value;
  }
  return false;
};
export const containsActiveChild = (parent, value) => {
  const children = parent && parent.props && parent.props.children;
  if (children == null) return false;
  let result = false;
  Children.forEach(children, child => {
    if (isChildActive(child, value)) {
      result = true;
    } else if (containsActiveChild(child, value)) {
      result = true;
    }
  });
  return result;
};